<template>
  <v-dialog
    :modelValue="value"
    data-cy="base-modal"
    :width="attrsFiltered.width || 'auto'"
    scrollable
    v-bind="attrsFiltered"
    @update:modelValue="v => (v ? show() : close())"
  >
    <v-card flat class="p-4!">
      <v-card-title class="headline">
        <slot v-if="slots.title" name="title" />
        <template v-else> {{ title }} </template>
      </v-card-title>
      <v-card-text>
        <slot v-if="slots.body" name="body" :opened="value" />
        <span v-else class="text-body text-black-0">{{ message }} </span>
      </v-card-text>
      <v-card-actions class="modal-card-actions-div">
        <slot v-if="slots.actions" name="actions" />
        <template v-else-if="!noButtons">
          <v-btn
            v-if="!hideCloseButton"
            size="large"
            data-cy="base-modal--close"
            class="px-8!"
            color="#6a6a6a"
            variant="outlined"
            @click="close"
          >
            {{ closeText || "Close" }}
          </v-btn>
          <RfButtonNew
            v-if="attrsFiltered.onPrimary || attrsFiltered.onSecondary"
            size="x-large"
            :disabled="disabledPrimary"
            data-cy="base-modal--submit"
            @click="
              v =>
                attrsFiltered.onPrimary ? attrsFiltered.onPrimary(v) : attrsFiltered.onSecondary(v)
            "
          >
            <span class="px-4"> {{ primaryText || secondaryText || "Save" }} </span>
          </RfButtonNew>
          <v-btn
            v-if="attrsFiltered.onError"
            size="large"
            variant="flat"
            data-cy="base-modal--error"
            class="ml-3! px-8!"
            color="error"
            @click="v => attrsFiltered.onError(v)"
          >
            {{ errorText || "Save" }}
          </v-btn>
        </template>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { computed, ref, useAttrs, useSlots } from "vue";
import RfButtonNew from "@/components/buttons/RfButtonNew.vue";

defineOptions({ inheritAttrs: false });
defineProps({
  title: { type: String, default: null },
  message: { type: String, default: null },
  primaryText: { type: String, default: null },
  closeText: { type: String, default: null },
  errorText: { type: String, default: null },
  secondaryText: { type: String, default: null },
  noButtons: { type: Boolean, default: false },
  disabledPrimary: { type: [Boolean, String], default: false },
  hideCloseButton: { type: Boolean, default: false },
});

const emit = defineEmits(["show", "close"]);

const value = ref(false);
const slots = useSlots();

const attrs = useAttrs();
const attrsFiltered = computed(() => {
  const { onPrimary, onSecondary, onError, ...rest } = attrs;
  return { ...rest, onPrimary, onSecondary, onError };
});

const show = () => {
  emit("show");
  value.value = true;
};

const close = () => {
  emit("close");
  value.value = false;
};

defineExpose({ show, close, value });
</script>

<style lang="scss" scoped>
.headline {
  font-size: 1.2rem !important;
}
</style>
